import { useSearchParams } from 'react-router-dom';

export type MediaTypeParam = 'video' | 'photo';

export const MEDIA_TYPE_QUERY_PARAM = 'mediaType';

export function useMediaTypeQuery(defaultType: MediaTypeParam = 'video') {
    const [searchParams, setSearchParams] = useSearchParams();

    const mediaTypeFromUrl = searchParams.get(MEDIA_TYPE_QUERY_PARAM);
    const mediaType: MediaTypeParam =
        mediaTypeFromUrl && isMediaTypeParam(mediaTypeFromUrl)
            ? mediaTypeFromUrl
            : defaultType;

    const updateMediaType = (newMediaType: MediaTypeParam) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set(MEDIA_TYPE_QUERY_PARAM, newMediaType);
        setSearchParams(newParams, { replace: true });
    };

    return {
        mediaType,
        updateMediaType,
    };
}

function isMediaTypeParam(value: string): value is MediaTypeParam {
    return ['video', 'photo'].includes(value);
}
